import { RIGHT_ARROW } from "../lib/assets";

export const FEATURE_TWO_LIST = [
  {
    id: 1,
    icon: "flaticon-profit",
    title: "Growing Business",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
  {
    id: 2,
    icon: "flaticon-investment",
    title: "Finance Investment",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
  {
    id: 3,
    icon: "flaticon-taxes",
    title: "Tax Advisory",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
];

export const FEATURE_THREE_LIST = [
  {
    id: 1,
    title: "Gap Analysis",
    subtitle:
      "Our consultant will conduct one-on-one sessions with process owners to review current processes, identify areas for improvement, and align them with the Standard's requirements",
    href: "/services",
    src: RIGHT_ARROW,
  },
  {
    id: 2,
    title: "Training",
    subtitle:
      "We provide training to process owners on Standard requirements and internal audit methodologies to assess Management System effectiveness.",
    href: "/services",
    src: RIGHT_ARROW,
  },
  {
    id: 3,
    title: "Documented Information",
    subtitle:
      "We develop customized documentation (Formats, Work Instructions, Process & System Controlling Procedures and Apex Manual) with process owners to clarify employee responsibilities and drive risk-free operations.",
    href: "/services",
    src: RIGHT_ARROW,
  },
  {
    id: 4,
    title: "Implementation Support",
    subtitle:
      "We conduct regular reviews with process owners to ensure timely project completion. TMC keeps process owners and top management informed of progress, issues, and corrective actions",
    href: "/services",
    src: RIGHT_ARROW,
  },
  {
    id: 5,
    title: "Internal Audit & MRM",
    subtitle:
      "We support your trained auditors in completing internal audits and management reviews. These processes help identify risks, improve internal controls, and ensure systems align with business objectives.",
    href: "/services",
    src: RIGHT_ARROW,
  },{
    id: 6,
    title: "Handling of Non-conformance",
    subtitle:
      "We help organizations systematically address non-conformities, identifying root causes and implementing corrective actions to prevent recurrences, drive improvement, and enhance customer satisfaction",
    href: "/services",
    src: RIGHT_ARROW,
  }
];

export const FEATURE_FOUR_LIST = [
  {
    id: 1,
    icon: "flaticon-life-insurance",
    title: "Tailored Solutions",
    subtitle: "We pride ourselves on customized designing and implementing solutions",
  },
  {
    id: 2,
    icon: "flaticon-handshake",
    title: "Industry Expertise",
    subtitle: "Our consultants bring a deep understanding of industry nuances.",
  },
  {
    id: 3,
    icon: "flaticon-business-presentation",
    title: "Comprehensive Approach",
    subtitle: "From design to implementation and evaluation, we offer end-to-end support",
  },
];

export const FEATURE_ONE_LIST = [
  {
    id: 1,
    icon: "flaticon-puzzle-piece",
    title: "Quality Services",
    subtitle: "Eiusmod Temporincididunt Ut Labore Magna Aliqua Quisery.",
  },
  {
    id: 2,
    icon: "flaticon-inspiration",
    title: "Innovation Ideas",
    subtitle: "Eiusmod Temporincididunt Ut Labore Magna Aliqua Quisery.",
  },
  {
    id: 3,
    icon: "flaticon-profit",
    title: "Business Growth",
    subtitle: "Eiusmod Temporincididunt Ut Labore Magna Aliqua Quisery.",
  },
];
